// extracted by mini-css-extract-plugin
export default {"container":"Cp-z","ratingLayout":"Dp-z","ratingLabel":"Ep-z","nonInteractiveRatingLabel":"Fp-z"};